import { style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles/breakpoints";
import { vars } from "plos/src/styles/theme.css";

export const profileContainer = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
  padding: vars.space.m,
  paddingTop: 0,
  color: vars.colors.onSurface,
  "@media": {
    [`screen and (min-width:${breakpoints[4]})`]: {
      gap: vars.space.m,
    },
  },
});
